var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, hasMany } from '@ember-data/model';

// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

export let IntegrationType = /*#__PURE__*/function (IntegrationType) {
  IntegrationType["GOOGLE_MY_BUSINESS"] = "GOOGLE_MY_BUSINESS";
  IntegrationType["FACEBOOK"] = "FACEBOOK";
  IntegrationType["GOOGLE_MERCHANT_CENTER"] = "GOOGLE_MERCHANT_CENTER";
  IntegrationType["SQ_LOCAL"] = "SQ_LOCAL";
  IntegrationType["META_COMMERCE"] = "META_COMMERCE";
  IntegrationType["GOOGLE_ADS"] = "GOOGLE_ADS";
  IntegrationType["DOORDASH"] = "DOORDASH";
  IntegrationType["UBEREATS"] = "UBEREATS";
  return IntegrationType;
}({});
let Integration = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('date'), _dec4 = attr('date'), _dec5 = hasMany('channels/channel'), _dec6 = hasMany('channels/integration-meta', {
  async: false
}), _class = class Integration extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "integrationType", _descriptor2, this);
    _initializerDefineProperty(this, "createdAt", _descriptor3, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor4, this);
    _initializerDefineProperty(this, "channels", _descriptor5, this);
    _initializerDefineProperty(this, "integrationMetas", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "integrationType", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "integrationMetas", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Integration as default };